<template>
  <div class="list-selector" :style="{ zIndex: zIndex || 4 }">
    <transition :name="transName('fade')">
      <div class="list-selector-mask animated" @touchmove="onTouchMove($event)" @click="close()" v-if="showBody"></div>
    </transition>
    <transition :name="transName('slide-up')">
      <div class="list-selector-body animated" v-if="showBody">
        <div class="value-list-content">
          <base-title
            :title="getStandardProps.title"
            ref="titleContainer"
            :show-close="true"
            @left-click="close"
            v-model="keyword"
            show-box-shadow
            show-border-radius
            :use-search="COMMON.getValue(getStandardProps, 'searchConfig.show')"
            :is-searching-mode="isFocusingSearch"
            @focus="focusSearch"
            @cancel-search="cancelSearch"
            :placeholder="COMMON.getValue(getStandardProps, 'searchConfig.placeholder')"
          />
          <div class="value-list-scroll" :class="{ single: single }" :style="{ height: listHeight }">
            <hly-scroll ref="lovListScroll" @pulling-up="loadMore" :pull-up-load="loadMoreFlag">
              <div class="data-list" :style="{ minHeight: bodyHeight }">
                <div
                  class="before-table-add-wrap"
                  v-if="operaAddConfig.show && !isFocusingSearch"
                  @click="operaAddConfig.add(operaAddConfigCallBack)"
                >
                  <div class="left-con">
                    <svg-icon type="add-btn" class="icon-add" />
                    <div>
                      <p class="title">{{ operaAddConfig.title }}</p>
                      <p class="sub-title">{{ operaAddConfig.subTitle }}</p>
                    </div>
                  </div>
                </div>
                <base-loading v-if="isLoadingData" type="LOADING"> </base-loading>
                <div
                  class="data-item"
                  :class="{ disabled: item[disabledKey] }"
                  v-for="item in renderList"
                  @click="selectItem(item)"
                >
                  <div class="data-img">
                    <svg-icon class="img" :type="item.selected ? 'circle-check' : 'circle-un-check'" />
                  </div>
                  <div class="content">
                    <div v-if="getStandardProps.columnsTitle" class="content-title">
                      {{ getStandardProps.columnsTitle(item) }}
                    </div>
                    <div class="content-des" v-for="(column, index) in getStandardProps.columns" :key="index">
                      {{ column.title ? `${column.title}：` : '' }}
                      {{ column.render(item[column.dataIndex], item) }}
                    </div>
                  </div>
                </div>
                <empty-content v-if="!isLoadingData && renderList.length === 0" :type="'nonData'"> </empty-content>
                <no-more v-if="!loadMoreFlag && renderList.length > 0"> </no-more>
              </div>
            </hly-scroll>
          </div>
          <div class="checkbox-button" ref="checkBoxFooter">
            <div class="select-all" @click="selectAll" v-if="!single && renderList.length > 0">
              <div class="div">
                <svg-icon :type="isSelectAll ? 'circle-check' : 'circle-un-check'" class="img" />
              </div>
              <div class="span">{{ $t('commonForm-1.key131', { cm: '全选' }) }}</div>
            </div>
            <div class="selected-num">
              {{ $t('global-1.key51', { arg1: selectedItem.length, cm: '已选 {arg1}' }) }}
            </div>
            <div class="select-button" @click="confirmEvent">{{ $t('common.key8', { cm: '确定' }) }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import BaseTitle from 'components/base-ui/base-title';
import chooserData from 'components/base-ui-v3/chooser/chooserData';
import hlyScroll from 'components/business/hly-scroll';
import baseLoading from 'components/base-ui/base-loading';
import EmptyContent from 'components/base-ui/empty-content';
import { fetch } from 'utils/fetch';
import { deepClone } from 'utils';
import store from '@/vuex';

export default {
  name: 'list-selector',
  components: {
    BaseTitle,
    hlyScroll,
    baseLoading,
    EmptyContent,
  },
  props: {
    value: {
      type: Array,
    },
    type: {
      type: String,
    },
    extraParams: {
      type: Object,
      default: () => ({}),
    },
    single: {
      type: Boolean,
      // default: false,
    },
    maxNum: {
      type: Number,
    },
    zIndex: {
      type: Number,
    },
    selectorItem: {
      type: Object,
    },
    operaAddConfig: {
      type: Object,
      default: () => ({}),
    },
    disabledKey: {
      type: String,
      default: 'disabled',
    },
  },
  data() {
    return {
      isFocusingSearch: false,
      listHeight: '',
      bodyHeight: '',
      loadMoreFlag: false,
      isLoadingData: true,
      list: [],
      page: 0,
      size: 10,
      focusAnimateTimer: undefined,
      selectedItem: [],
      keyword: '',
      popFn: undefined,
      showBody: false,
    };
  },
  computed: {
    getStandardProps() {
      let res;
      if (this.selectorItem) {
        res = this.selectorItem;
      } else {
        res = chooserData[this.type];
      }
      return res || {};
    },
    renderList() {
      if (this.isFocusingSearch) {
        if (!this.keyword.trim() || this.showLoading) {
          return [];
        }
      }
      const { map } = this.getStandardProps;
      if (map && typeof map === 'function') {
        return map(this.list);
      }
      return this.list;
    },
    isSelectAll() {
      return this.selectedItem.length === this.list.filter((item) => !item[this.disabledKey]).length;
    },
    // 到达数量选择上限
    isReachMaximum() {
      return this.maxNum && this.selectedItem.length >= this.maxNum;
    },
  },
  mounted() {
    this.pushOpeningModal(
      (this.popFn = () => {
        this.$emit('onCancel');
      })
    );
    this.showBody = true;
    this.$nextTick(() => {
      this.selectedItem = deepClone(this.value);
      this.updateListHeight();
      this.doFetchData(false);
    });
  },
  methods: {
    pushOpeningModal(fun) {
      store.commit('pushOpeningModal', fun);
    },
    popOpeningModal(fun) {
      store.commit('popOpeningModal', fun);
    },
    doFetchData(loadMoreFlag, keyword) {
      if (loadMoreFlag) {
        this.page = this.page + 1;
      } else {
        this.list = [];
        this.page = 0;
        this.isLoadingData = true;
      }
      let temp = {
        url: this.getStandardProps.url,
        method: this.getStandardProps.method || 'GET',
      };
      if (temp.method === 'GET') {
        temp.params = {
          page: this.page,
          size: this.size,
          ...this.extraParams,
        };
        if (keyword) {
          temp.params = Object.assign(temp.params, {
            ...(this.getStandardProps.filterSearchParams
              ? this.getStandardProps.filterSearchParams(keyword)
              : {
                  [this.getStandardProps.searchConfig.key]: keyword,
                }),
          });
        }
      } else {
        temp.params = {
          page: this.page,
          size: this.size,
        };
        temp.data = {
          ...this.extraParams,
        };
        if (keyword) {
          temp.data = Object.assign(temp.data, {
            ...(this.getStandardProps.filterSearchParams
              ? this.getStandardProps.filterSearchParams(keyword)
              : {
                  [this.getStandardProps.searchConfig.key]: keyword,
                }),
          });
        }
      }
      let getListPromise;
      if (this.getStandardProps.service) {
        getListPromise = this.getStandardProps.service(temp);
      } else {
        getListPromise = fetch(temp);
      }
      getListPromise
        .then((res) => {
          this.isLoadingData = false;
          let list;
          let total;
          // 目前支持2格式
          // 返回时list 总数通过header获取 如果获取不到默认为不分页
          // 返回为map list取rows total取total
          if (Array.isArray(res.data)) {
            list = res.data;
            total =
              +this.COMMON.getValue(res.headers, 'x-total-count') ||
              +this.COMMON.getValue(res.headers, 'X-Total-Count') ||
              0;
          } else {
            list = res.data.rows;
            total = res.data.total;
          }
          list.forEach((item) => {
            item.selected = false;
            this.selectedItem.forEach((record, index) => {
              if (
                item[this.getStandardProps.key] ===
                (typeof record === 'object' ? record[this.getStandardProps.key] : record)
              ) {
                item.selected = true;
                this.selectedItem[index] = item;
              }
            });
            this.list.push(item);
          });
          this.$nextTick(() => {
            this.$refs.lovListScroll && this.$refs.lovListScroll.forceUpdate();
            this.$refs.lovListScroll && this.$refs.lovListScroll.reset();
          });
          this.loadMoreFlag = total !== this.list.length;
          if (total === 0) {
            this.loadMoreFlag = false;
          }
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.COMMON.errorHandle(err);
        });
    },
    onTouchMove($event) {
      $event.preventDefault();
    },
    close() {
      this.showBody = false;
      this.$nextTick(() => {
        this.$emit('onCancel');
        this.popOpeningModal(this.popFn);
      });
    },
    updateListHeight() {
      let $refs = this.$refs || {};
      // 头部高度
      let titleContainer = $refs.titleContainer || {};
      let title = titleContainer.$el;
      let titleHeight = title ? parseFloat(window.getComputedStyle(title).height) : 0;
      // 底部按钮高度
      let checkBoxFooterContainer = $refs.checkBoxFooter || {};
      let footerHeight = checkBoxFooterContainer.offsetHeight;

      let height = titleHeight + footerHeight + 'px';
      this.listHeight = `calc(100% - ${height})`;
      this.bodyHeight = `calc(100vh - ${height})`;
    },
    focusSearch() {
      if (this.focusAnimateTimer) {
        clearTimeout(this.focusAnimateTimer);
      }
      // 100ms防止点击穿透失焦 移除
      this.focusAnimateTimer = setTimeout(() => {
        this.isFocusingSearch = true;
        if (this.updateScrollTimer) {
          clearTimeout(this.updateScrollTimer);
        }
        // 300ms更新scroll高度
        this.updateScrollTimer = setTimeout(() => {
          this.updateListHeight();
        }, 320);
      });
    },
    cancelSearch() {
      this.isFocusingSearch = false;
      this.keyword = '';
      if (this.updateScrollTimer) {
        clearTimeout(this.updateScrollTimer);
      }
      this.updateScrollTimer = setTimeout(() => {
        this.updateListHeight();
      }, 320);
    },
    loadMore() {
      this.doFetchData(true, this.keyword);
    },
    operaAddConfigCallBack(data) {
      this.selectItem(data);
      this.doFetchData();
    },
    selectItem(data) {
      // 不可选不做操作
      if (data[this.disabledKey]) {
        return !1;
      }
      let index = this.selectedItem.findIndex(
        (item) => item[this.getStandardProps.key] === data[this.getStandardProps.key]
      );
      if (this.single) {
        this.list.map((item) => (item.selected = false));
        if (index === -1) {
          data.selected = true;
          this.selectedItem = [data];
        } else {
          data.selected = false;
          this.selectedItem = [];
        }
      } else {
        if (index === -1) {
          if (this.isReachMaximum) {
            this.$handPlugin.toast.show(window.$t('global-1.key317', { arg1: this.maxNum, cm: '最大可选{arg1}' }));
            return;
          }
          data.selected = true;
          this.selectedItem.push(data);
        } else {
          data.selected = false;
          this.selectedItem.splice(index, 1);
        }
      }
    },
    selectAll() {
      if (this.isSelectAll) {
        this.selectedItem = [];
        this.list.map((item) => (item.selected = false));
      } else {
        this.selectedItem = [];
        this.list.map((item) => {
          if (!this.isReachMaximum && !item[this.disabledKey]) {
            item.selected = true;
            this.selectedItem.push(item);
          }
        });
        this.isReachMaximum &&
          this.$handPlugin.toast.show(window.$t('global-1.key317', { arg1: this.maxNum, cm: '最大可选{arg1}' }));
      }
    },
    confirmEvent() {
      this.$emit(
        'onOk',
        this.selectedItem.map((item) => {
          delete item.selected;
          return item;
        })
      );
      this.popOpeningModal(this.popFn);
    },
  },
  watch: {
    keyword(val) {
      if (val.trim() !== '') {
        this.doFetchData(false, val);
      } else {
        this.doFetchData(false);
      }
    },
  },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/variable.scss';
.list-selector {
  position: fixed;
  width: 100vw;
  height: 100%;
  top: 0;
  left: 0;
  .list-selector-mask {
    height: 100%;
    width: 100vw;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
  }
  .list-selector-body {
    top: px(60);
    width: 100vw;
    height: 100%;
    overflow: hidden;
    position: absolute;
    .before-table-add-wrap {
      height: 128px;
      background: #fff;
      margin: 0 0 16px;
      padding: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      box-shadow: inset 0 -2px 0 0 #d7dce6;
      .left-con {
        display: flex;
        align-items: center;
        .icon-add {
          font-size: 48px;
          color: $mainColor;
          margin-right: 30px;
        }
        .title {
          font-size: 30px;
          line-height: 34px;
          color: #0a0f1e;
        }
        .sub-title {
          font-size: 24px;
          color: #8b90a0;
        }
      }
    }
    .value-list-content {
      position: relative;
      height: calc(100% - 60px);
      .value-list-scroll {
        position: relative;
        background: #ffffff;
        .data-list {
          background: #ffffff;
          height: 100%;
          .data-item {
            display: flex;
            align-items: center;
            padding: px(24);
            background: #ffffff;
            box-shadow: inset 0 -2px 0 0 #d7dce6;
            .data-img {
              width: px(32);
              height: px(32);
              text-align: left;
              margin-right: px(24);
              .img {
                font-size: 32px;
                color: $mainColor;
              }
            }
            .content {
              max-width: calc(100% - 0.28rem);
              .content-title {
                font-size: px(28);
                line-height: px(44);
                margin-bottom: px(8);
                color: #252629;
              }
              .content-des {
                font-size: px(24);
                line-height: px(36);
                color: #71757e;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                word-break: break-word;
              }
            }
            .data-text {
              font-size: px(30);
              color: #505564;
              line-height: px(40);
            }
            &.disabled {
              background: #f3f4f5;
              color: #bec8d2;
            }
          }
          .guide {
            text-align: center;
            padding: px(12) 0;
            margin-left: px(20);
          }
        }
      }
      .checkbox-button {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: #ffffff;
        box-shadow: 0 -8px 16px 0 rgba(0, 0, 0, 0.1);
        padding: px(14) px(30);
        display: flex;

        .select-all {
          text-align: center;
          margin-right: px(20);
          height: px(80);
          padding: px(4) 0;
          .div {
            height: px(40);
            .img {
              width: px(32);
              height: px(32);
              color: $mainColor;
            }
          }
          .span {
            font-weight: 400;
            font-size: px(20);
            line-height: px(32);
            text-align: center;
            color: #252629;
          }
        }

        .selected-num {
          width: px(200);
          margin-right: px(20);
          height: px(76);
          line-height: px(76);
          border: 2px solid $mainColor;
          border-radius: px(10);
          font-family: PingFangSC-Regular;
          font-size: px(30);
          color: #1f86f6;
          text-align: center;
        }

        .select-button {
          flex: 1;
          background: $mainColor;
          height: px(80);
          line-height: px(80);
          border-radius: px(10);
          font-family: PingFangSC-Medium;
          font-size: px(30);
          color: #ffffff;
          text-align: center;
        }
      }
    }
  }
}
</style>
